import { ArrowRight, ScanSearch, LineChart, Shapes, Radio, Gauge, ShieldHalf } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SectionHeader, Cta } from '../common';
import { EXT, openExternal } from '../../config/links';
import TradingTerminal from '../TradingTerminal';

const CAPS = [
  { icon: ScanSearch, t: 'AI market scanning' },
  { icon: LineChart, t: 'Technical scans' },
  { icon: Shapes, t: 'Pattern scans' },
  { icon: Radio, t: 'Strategy signals' },
  { icon: Gauge, t: 'Market condition analysis' },
  { icon: ShieldHalf, t: 'Risk-aware trade setups' },
];

export default function AITradeEngineSection() {
  return (
    <section className="section" style={{ background: 'var(--bg-2)', borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)' }}>
      <div className="container-x">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="reveal">
            <SectionHeader eyebrow="AI Trade Engine" title="Your market intelligence, running continuously." sub="The engine never sleeps — scanning conditions, reading structure and surfacing risk-aware setups with a clear confidence score." />
            <div className="grid grid-cols-2 gap-3 mt-8">
              {CAPS.map((c) => (
                <div key={c.t} className="flex items-center gap-2.5 panel p-3.5">
                  <c.icon size={17} className="text-[var(--gold-2)] shrink-0" />
                  <span className="text-[13.5px] text-[var(--text)]">{c.t}</span>
                </div>
              ))}
            </div>
            <div className="mt-8"><Link to="/ai-trade-engine" className="btn-gold inline-flex items-center gap-2 rounded-xl h-12 px-7 text-[15px] font-semibold">View AI Trade Engine <ArrowRight size={16} /></Link></div>
          </div>
          <div className="reveal"><TradingTerminal compact /></div>
        </div>
      </div>
    </section>
  );
}
